import { DownloadFileIcon } from 'components/Icons';

import { ChoosePDFModal } from './ChoosePDFModal';

import { registerProjectOption } from '../options';

registerProjectOption({
  Icon: DownloadFileIcon,

  overlay: ChoosePDFModal,

  modal: 'CHOOSE_PDF',

  hidden: true,

  shortcut: {
    key: 'P',
    triggerKey: 'ctrl',
  },

  useOption: ({ openModal }) => {
    return {
      action: () => openModal('CHOOSE_PDF'),

      isEnabled: true,
    };
  },
});
